// Handle resizing the height of the iframe when there are no reviews
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    // Mutation Observer
    function watchDOMChanges(element, callback) {
      // Setup observer with callback
      const observer = new MutationObserver(function(mutationsList) {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            if (mutation.addedNodes.length >= 1) {
              callback(mutation, observer);
            }
          }
        }
      });

      // Start observing the target element with config
      observer.observe(element, {
        childList: true,
        attributes: false,
        subtree: false
      });

      return observer;
    }

    function mainCallback(mutation, observer) {
      if (mutation.addedNodes[0].tagName === 'IFRAME') {
        resizeIframe(observer);
      }
    }

    function resizeIframe(observer) {
      const widget = document.querySelector('div.trustpilot-widget');
      if (!widget) {
        throw new Error('Unable to find trust pilot widget element');
      }

      const encodedSku = encodeURIComponent(widget?.getAttribute('data-sku') || '');
      const templateId = encodeURIComponent(widget?.getAttribute('data-template-id') || '');
      const businessUnitId = encodeURIComponent(widget?.getAttribute('data-businessunit-id') || '');
      const locale = encodeURIComponent(widget?.getAttribute('data-locale') || '');

      const url = 'https://widget.trustpilot.com/trustbox-data';
      const urlFinal = `${url}/${templateId}?businessUnitId=${businessUnitId}&locale=${locale}&sku=${encodedSku}`;

      fetch(urlFinal)
        .then(function(response) {
          if (!response.ok) {
            throw new Error(`HTTP error - Status: ${response.status}`);
          }
          return response.json();
        })
        .then(function(data) {
          const hasReviews = data?.productReviews?.reviews?.length || false;
          if (!hasReviews) {
            const iframe = document.querySelector('div.trustpilot-widget iframe');
            iframe.style.height = '100px';
          }

          observer.disconnect();
        })
        .catch(function(error) {
          console.error(`Error fetching data from url "${url}":`, error);
        });
    }

    // Main
    const widget = document.querySelector('div.trustpilot-widget');
    watchDOMChanges(widget, mainCallback);
  });
})();